import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DropdownRight from "./DropdownRight";
import HeaderLeft from "./HeaderLeft";
import http from "../services/http";
import GetStorage from "../services/Storage";
import { ToastContainer } from "react-toastify";
import { showToast } from "./ShowToast";
import { SpinnerCircular } from "spinners-react";
import storage from "../services/Storage";

function EditSettings() {
  const [uploadSpin, setUploadSpin] = useState(false);

  let user = localStorage.getItem("user");
  user = JSON.parse(user);
  const token = GetStorage.get("xAuthToken");
  const [video, setVideos] = useState(user.data.work_limit);
  const [availibility, setavailibility] = useState(user.data.is_available);

  const handleChanges = (event) => {
    // Only allow positive integers up to 1000 (disallow characters, 0, negative numbers, and values > 1000)
    let val = event.target.value.replace(/[^0-9]/g, "");
    val = val.replace(/^0+/, "");
    if (val !== "" && parseInt(val, 10) > 1000) {
      val = "1000";
    }
    setVideos(val);
  };

  const availibilityChange = (e) => {
    // console.log(e.target.checked);
    const v = e.target.checked === true ? 1 : 0;
    setavailibility(v);
  };

  const handleUpdate = () => {
    const numValue = parseInt(video, 10);
    if (!video || isNaN(numValue) || numValue <= 0) {
      showToast("error", "Please enter a valid work limit greater than 0");
      return;
    }
    if (numValue > 1000) {
      showToast("error", "Work limit cannot be greater than 1000");
      return;
    }
    setUploadSpin(true);
    http
      .put(`api/analyst/settings?token=${token}`, {
        is_available: availibility,
        work_limit: video,
      })
      .then((res) => {
        showToast("success", res.data.message);
        setUploadSpin(false);

        http
          .get(`api/common/me?token=${token}`)
          .then((res) => {
            const newUser = user;
            newUser.data = res.data;
            storage.store("user", newUser);
          })
          .catch((err) => {
            console.log("error ", err.response.data.errors);
          });
      })
      .catch((error) => {
        setUploadSpin(false);

        console.log("error ", error.response.data.errors);
      });
  };

  useEffect(() => {
    http
      .get(`api/common/me?token=${token}`)
      .then((res) => {
        const newUser = user;
        newUser.data = res.data;
        storage.store("user", newUser);
      })
      .catch((err) => {
        console.log("error ", err.response.data.errors);
      });
  }, []);

  return (
    <>
      <header>
        <div className="custom_container ">
          <HeaderLeft />
          <div className="user_profile">
            <DropdownRight />
          </div>
        </div>
      </header>
      <section className="otp_verification custom_hight">
        <div className="login_inner">
          <h1 className="mb_30 main_title ">Edit Settings</h1>
          <p className="mb_40 them_para text-center mx-auto text_limit">
            Set the maximum number of works assignments.
          </p>
          <div className="switch_wraper">
            <span style={{ marginRight: "15px" }}>
              {availibility === 1 ? "Available" : "Unavailable"}
            </span>
            <input
              type="checkbox"
              hidden="hidden"
              id="two"
              onChange={availibilityChange}
              checked={availibility === 1 ? true : false}
            />
            <label className="switch" htmlFor="two"></label>
          </div>
          <form
            action="index_submit"
            className="Edit_Setting"
            method="get"
            acceptCharset="utf-8"
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="form-group icon mt-3">
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={4}
                max={1000}
                className="form-control custom_input"
                value={video}
                onChange={handleChanges}
                placeholder="Enter work limit"
              />
            </div>
          </form>
          <div className="btn_wraper">
            <button
              type="button"
              className="them_btn mt_40 mb_30"
              onClick={handleUpdate}
              style={{ verticalAlign: "middle" }}
            >
              {uploadSpin ? (
                <SpinnerCircular className="button-spin" style={{ height: "38px", width: "38px", verticalAlign: "middle" }} />
              ) : (
                " Update"
              )}
            </button>
            <Link to="/accountSettings" style={{ verticalAlign: "middle" }}>
              <button type="button" className="them_btn_ouline mt_40 mb_30 ml-2" style={{ verticalAlign: "middle" }}>
                Go Back
              </button>
            </Link>
          </div>
        </div>
      </section>
      <ToastContainer />
    </>
  );
}

export default EditSettings;
